import React from "react";
import { geoCentroid } from "d3-geo";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  Annotation
} from "react-simple-maps";

const allStates =  [
  {
    "id": "AL",
    "val": "01",
    "bgcolor": "green",
    "pharmacy": 10,
    "client": 20,
    "region": "Northeast"
  },
  {
    "id": "AR",
    "val": "05",
    "bgcolor": "green",
    "pharmacy": 10,
    "client": 12,
    "region": "Northeast"
  },
  {
    "id": "DE",
    "val": "10",
    "bgcolor": "red",
    "pharmacy": 10,
    "client": 20,
    "region": "MidAtlantic"
  }, 
   {
    "id": "FL",
    "val": "12",
    "bgcolor": "red",
    "pharmacy": 10,
    "client": 20,
    "region": "MidAtlantic"
  },
  {
    "id": "GU",
    "val": "66",
    "bgcolor": "red",
    "pharmacy": 30,
    "client": 20,
    "region": "Southease"
  },
  {
    "id": "HI",
    "val": "15",
    "bgcolor": "red",
    "pharmacy": 10,
    "client": 20,
    "region": "Southease"
  },
  {
    "id": "ID",
    "val": "16",
    "bgcolor": "red",
    "pharmacy": 10,
    "client": 20,
    "region": "Southease"
  },
  
];

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const offsets = {
  VT: [50, -8],
  NH: [34, 2],
  MA: [30, -1],
  RI: [28, 2],
  CT: [35, 10],
  NJ: [34, 1],
  DE: [33, 0],
  MD: [47, 10],
  DC: [49, 21]
};

const MapChart = () => {
  const allStatesArray = Array.isArray(allStates) ? allStates : [];
  return (
    <ComposableMap projection="geoAlbersUsa">
      <Geographies geography={geoUrl}>
        {({ geographies }) => (
          <>
            {geographies.map(geo => (
              <Geography
                key={geo.rsmKey}
                stroke="#FFF"
                geography={geo}
                fill="#DDD"
              />
            ))}
            {geographies.map(geo => {
              const centroid = geoCentroid(geo);
              const cur = allStates.find(s => s.val === geo.id);
              return (
                <g key={geo.rsmKey + "-name"}>
                  {cur &&
                    centroid[0] > -160 &&
                    centroid[0] < -67 &&
                    (Object.keys(offsets).indexOf(cur.id) === -1 ? (
                      <Marker coordinates={centroid}>
                        <text y="2" fontSize={14} textAnchor="middle">
                          {cur.id}
                        </text>
                      </Marker>
                    ) : (
                      <Annotation
                        subject={centroid}
                        dx={offsets[cur.id][0]}
                        dy={offsets[cur.id][1]}
                      >
                        <text x={4} fontSize={14} alignmentBaseline="middle">
                          {cur.id}
                        </text>
                      </Annotation>
                    ))}
                </g>
              );
            })}
          </>
        )}
      </Geographies>
    </ComposableMap>
  );
};

export default MapChart;
